module.exports = __webpack_public_path__ + "img/Splash_Shadowbox_Left.fb9ab0e6.jpg";